import React from 'react';
import { useAuth } from 'react-oidc-context';
import {
  Breadcrumb,
  BreadcrumbItem,
  Content,
  EmptyState,
  EmptyStateBody,
  Icon,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
} from '@patternfly/react-core';
import { CubesIcon } from '@patternfly/react-icons';
import Unauthenticated from '@app/Unauthenticated';

function Containers() {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return <Unauthenticated />;
  }

  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem to="/datacenter">Datacenter</BreadcrumbItem>
          <BreadcrumbItem isActive>Containers</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection hasBodyWrapper variant={PageSectionVariants.default} isWidthLimited hasShadowBottom={true}>
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <CubesIcon />
          </Icon>
          Containers
        </Content>
        <Content component="p">Manage your container workloads</Content>
      </PageSection>
      <PageSection hasBodyWrapper={false}>
        <EmptyState titleText="Coming soon" icon={CubesIcon} variant="lg" headingLevel="h2">
          <EmptyStateBody>Container management is not yet available.</EmptyStateBody>
        </EmptyState>
      </PageSection>
    </>
  );
}

export { Containers };
